'use strict';

// This JS file isn't run through Babel - only JS supported by target browsers should be used

(function () {
  var $form = window.jQuery('#metafields_form')

  if ($form.length === 0) {
    console.warn('ACF metafields form not found')
    return
  }

  var $submit = $form.find('[type="submit"], button:not([type])')
  var $message
  var $fieldsWithErrors
  var fieldErrorClass = 'form__field-error'
  var isSubmitting = false
  var submitText
  var action = $form.data('form-action')
  var submittedData

  var addSuccessMessage = function(message) {
    $message = $('<div class="form__success">' + message + '</div>')
    $form.prepend($message)
  }

  var addErrorMessage = function(message) {
    $message = $('<div class="form__error">' + message + '</div>')
    $form.prepend($message)
  }

  var removeMessage = function() {
    if ($message) {
      $message.remove()
      $message = null
    }
  }

  var addFieldErrors = function(errors) {
    Object.keys(errors).forEach(function(key) {
      var errorText = errors[key].join(', ')
      var $input = $form.find('[name="customer[' + key + ']"]')
      $input.addClass('has-error')
      $input.after('<p class="' + fieldErrorClass + '">' + errorText + '</p>')

      if (!$fieldsWithErrors) {
        $fieldsWithErrors = $input
      } else {
        $fieldsWithErrors = $fieldsWithErrors.add($input)
      }
    })
  }

  var removeFieldErrors = function() {
    if ($fieldsWithErrors) {
      $fieldsWithErrors.removeClass('has-error')
      $fieldsWithErrors.next('.' + fieldErrorClass).remove()
      $fieldsWithErrors = null
    }
  }

  var onComplete = function(data) {
    isSubmitting = false

    $form.removeClass('is-submitting')

    $submit.prop('disabled', false)
    $submit.text(submitText)

    // Example response data:
    // { status: "OK", message: "Fields updated" }
    // { status: "ERROR", message: "Error updating customer properties", errors: { email: ["can't be blank"] }}

    if (data.status === 'OK') {
      switch (action) {
        case 'register':
          if (window.location.search.indexOf('return_url=%2Fcart') > -1) {
            // If coming from cart page, redirect back to there
            window.location = '/cart'
          } else {
            // Storage used to show post-registration message in templates/customers/login
            sessionStorage.setItem('customer-registered', 1)
            window.location = '/account/login'
          }
          break

        default:
          addSuccessMessage(data.message)
          break
      }
    } else if (data.status === 'ERROR') {
      addErrorMessage(data.message)
      addFieldErrors(data.errors)
    }
  }

  var validateBeforeSend = function() {
    if (isSubmitting) return false
    isSubmitting = true

    var isValid = $form[0].reportValidity()

    if (isValid) {
      $form.addClass('is-submitting')

      submitText = $submit.eq(0).text()
      $submit.prop('disabled', true)
      $submit.text('Submitting…')

      removeMessage()
      removeFieldErrors()

      submittedData = $form.serializeArray()
    }

    return isValid
  }

  // See https://my.accentuate.io/c/how-to/allow-customers-to-edit-own-fields for information about
  // the Accentuate proxy script (under 'Submitting the form')
  Accentuate($form, onComplete, validateBeforeSend)
})()
